import axios from "axios";

// У `npm start` без змінної ходимо на той самий origin — setupProxy.js
// перешле /api на локальний бекенд (працює і через ngrok).
const BACKEND =
  process.env.REACT_APP_BACKEND_URL ||
  (process.env.NODE_ENV === "development" ? "" : "https://smak.bar");

const api = axios.create({
  baseURL: `${BACKEND.replace(/\/$/, "")}/api`,
});

// === Attach token ===
api.interceptors.request.use((config) => {
  const access = localStorage.getItem("access");
  if (access) {
    config.headers.Authorization = `Bearer ${access}`;
  }
  return config;
});

// === Auto-refresh ===
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const refresh = localStorage.getItem("refresh");
      if (!refresh) return Promise.reject(error);

      try {
        const resp = await axios.post(
          `${BACKEND}/api/auth/token/refresh/`,
          { refresh }
        );

        localStorage.setItem("access", resp.data.access);

        api.defaults.headers.Authorization = `Bearer ${resp.data.access}`;
        originalRequest.headers.Authorization = `Bearer ${resp.data.access}`;

        return api(originalRequest);
      } catch (err) {
        return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
